import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex topbar align-items-center d-lg-none ms-n2 me-3",
  title: "Show aside menu"
}
const _hoisted_2 = {
  class: "\n            btn btn-icon btn-active-light-primary\n            w-30px\n            h-30px\n            w-md-40px\n            h-md-40px\n          ",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_3 = { class: "svg-icon svg-icon-2x" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "header-logo me-5 me-md-10 flex-grow-1 flex-lg-grow-0" }, [
  /*#__PURE__*/_createVNode("a", { href: "#" }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Logo",
      src: "media/logos/logo-4.png",
      class: "logo-default h-25px"
    }),
    /*#__PURE__*/_createVNode("img", {
      alt: "Logo",
      src: "media/logos/logo-5.png",
      class: "logo-sticky h-25px"
    })
  ])
], -1)
const _hoisted_5 = { class: "\n          d-flex\n          align-items-stretch\n          justify-content-between\n          flex-lg-grow-1\n        " }
const _hoisted_6 = {
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_7 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createBlock("div", {
    id: "kt_header",
    class: "header align-items-stretch",
    "data-kt-sticky": _ctx.isHeaderSticky,
    "data-kt-sticky-name": "header",
    "data-kt-sticky-offset": "{default: '200px', lg: '300px'}"
  }, [
    _createVNode("div", {
      class: [{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-center"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs015.svg" })
          ])
        ])
      ]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_KTMenu)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ], 8, ["data-kt-sticky"]))
}